import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  const symptoms = ['el pecho se te sube,', 'la garganta se te cierra,', 'la mandíbula se te traba,', 'y tu paciencia… desaparece.'];
  return <section className="py-20 md:py-32 px-6 bg-cream-200" data-id="element-131">
      <div className="max-w-2xl mx-auto" data-id="element-132">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-133">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-charcoal mb-6" data-id="element-134">
            Esto no es "más autocuidado". <br data-id="element-135" />
            <span className="text-terracotta-dark italic" data-id="element-136">
              Es un botón de emergencia.
            </span>
          </h2>
          <p className="text-lg text-charcoal-light leading-relaxed" data-id="element-137">
            No te estoy vendiendo velas, afirmaciones ni "energía femenina". Te
            estoy ofreciendo algo mucho más útil cuando estás al límite: un
            protocolo de manos.
          </p>
        </motion.div>

        <div className="space-y-8 mb-16" data-id="element-138">
          <p className="text-lg font-medium text-charcoal" data-id="element-139">
            Porque cuando estás activada:
          </p>
          <ul className="space-y-4 pl-4" data-id="element-140">
            {symptoms.map((item, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-center text-lg md:text-xl text-charcoal-light" data-id="element-141">
                <span className="w-2 h-2 rounded-full bg-terracotta mr-4 flex-shrink-0" data-id="element-142" />
                {item}
              </motion.li>)}
          </ul>
        </div>

        <motion.blockquote initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="border-l-4 border-terracotta pl-6 py-2 my-16 bg-white/40 rounded-r-lg" data-id="element-143">
          <p className="text-2xl md:text-3xl font-serif italic text-charcoal" data-id="element-144">
            "No quería hablar así."
          </p>
        </motion.blockquote>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-6" data-id="element-145">
          <h3 className="text-2xl font-serif font-bold text-charcoal" data-id="element-146">
            La verdad incómoda
          </h3>
          <h4 className="text-xl text-terracotta-dark font-medium" data-id="element-147">
            No es que sos "mala". Es que tu sistema está saturado.
          </h4>
          <p className="text-lg text-charcoal-light leading-relaxed" data-id="element-148">
            La maternidad en 2026 no se vive con pausa. Se vive con
            interrupciones. Y tu cuerpo lo registra como amenaza constante:
            ruido, contacto, demandas, culpa, falta de sueño.
          </p>
          <p className="text-lg text-charcoal-light leading-relaxed" data-id="element-149">
            Entonces te piden que hagas lo peor posible:
            <br data-id="element-150" />
            <span className="italic font-medium text-charcoal" data-id="element-151">
              "Respirá hondo, calmate, contá hasta diez."
            </span>
          </p>
          <p className="text-lg text-charcoal-light leading-relaxed" data-id="element-152">
            Como si pudieras negociar con un cuerpo que ya encendió la alarma.
          </p>
        </motion.div>
      </div>
    </section>;
}